import { Dialog, DialogContent, Divider, Grid } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPaymentConfigRequest } from "../../store/shopping/shopping.actions";
import { getPaymentConfig } from "../../store/shopping/shopping.selector";
import Cards from "react-credit-cards";
import ManageCard from "./ManageCard";
import "react-credit-cards/es/styles-compiled.css";
import { getUserProfile } from "../../store/user/user.selector";
import Swal from "sweetalert2";
import ShoppingAPI from "../../store/shopping/shopping.api";

const Payment = () => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [showCard, setShowCard] = useState(false);
    const [selected, setSelected] = useState({});

    const { paymentConfig, userProfile } = useSelector((state) => {
        return {
            paymentConfig: getPaymentConfig(state),
            userProfile: getUserProfile(state),
        };
    });

    useEffect(() => {
        dispatch(fetchPaymentConfigRequest());
    }, []);

    return (
        <div>
            <div className="mb-3.5">
                <h3 className="text-base font-bold text-ebony-color">
                    Payment Method
                </h3>
                <p className="text-sm font-medium text-black-60">
                    Save payment information for subscriptions and purchases
                </p>
            </div>

            <div className="">
                <div
                    className={`rounded-md bg-white border border-black-10 mb-2`}
                >
                    <div
                        onClick={() => setShow(!show)}
                        className="flex justify-between items-center w-full h-[50px] pl-[9px] pr-4 cursor-pointer"
                    >
                        <div
                            className={`${
                                show ? "text-ebony-color" : "text-black-50"
                            } flex items-center hover:text-ebony-color  w-full`}
                        >
                            <span className="mr-[11px]">
                                <svg
                                    width="20"
                                    height="16"
                                    className="stroke-current"
                                    viewBox="0 0 20 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M1 6.2334H19M5 11.2334H6M10 11.2334H11M4 15.2334H16C17.6569 15.2334 19 13.8903 19 12.2334V4.2334C19 2.57654 17.6569 1.2334 16 1.2334H4C2.34315 1.2334 1 2.57654 1 4.2334V12.2334C1 13.8903 2.34315 15.2334 4 15.2334Z"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </span>
                            <p className="text-sm capitalize w-full">
                                Credit/ Debit card
                                <span
                                    className="float-right"
                                    onClick={() => setShowCard(true)}
                                >
                                    Add New Card
                                </span>
                            </p>
                        </div>
                    </div>
                    <Divider />
                    {/* content  */}
                    <Grid container spacing={2} className="p-3">
                        {paymentConfig &&
                            paymentConfig.cards &&
                            paymentConfig.cards.map((x) => {
                                return (
                                    <Grid item xs={12} sm={12} md={4} lg={4}>
                                        <Cards
                                            cvc={""}
                                            expiry={
                                                x.expMonth.toString() +
                                                x.expYear.toString()
                                            }
                                            preview={true}
                                            name={userProfile.fullName}
                                            number={"XXXXXXXXXXXX" + x.last4}
                                            issuer={x.brand}
                                            callback={(x) => {}}
                                        />
                                        <div className="flex align-items justify-between my-2">
                                            <button
                                                onClick={() => {
                                                    setShowCard(true);
                                                    setSelected(x);
                                                }}
                                                disabled={
                                                    x.id.indexOf("pm_") > -1
                                                }
                                                className={`py-[7px] w-full px-5 bg-orange-color rounded-lg text-sm border border-orange-color font-bold text-white flex items-center justify-center capitalize mr-2 ${
                                                    x.id.indexOf("pm_") > -1
                                                        ? "opacity-50"
                                                        : ""
                                                }`}
                                            >
                                                <span className="mr-2.5">
                                                    <svg
                                                        width="15"
                                                        height="15"
                                                        viewBox="0 0 15 15"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M6.75 2.34473H3C2.17157 2.34473 1.5 3.0163 1.5 3.84473V12.0947C1.5 12.9232 2.17157 13.5947 3 13.5947H11.25C12.0784 13.5947 12.75 12.9232 12.75 12.0947V8.34473M11.6893 1.28407C12.2751 0.69828 13.2249 0.69828 13.8107 1.28407C14.3964 1.86985 14.3964 2.8196 13.8107 3.40539L7.37132 9.84473H5.25L5.25 7.72341L11.6893 1.28407Z"
                                                            stroke="white"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                                <span>Edit</span>
                                            </button>
                                            <button
                                                disabled={
                                                    x.id.indexOf("pm_") > -1
                                                }
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Confirm delete?",
                                                        text: "A deleted card be restored later.",
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor:
                                                            "red",
                                                        cancelButtonText:
                                                            "Cancel",
                                                        confirmButtonText:
                                                            "Delete",
                                                        customClass: {
                                                            cancelButton:
                                                                "order-1 right-gap",
                                                            confirmButton:
                                                                "order-2",
                                                            denyButton:
                                                                "order-3",
                                                        },
                                                    }).then((result) => {
                                                        if (
                                                            result.isConfirmed
                                                        ) {
                                                            ShoppingAPI.DeleteCard(
                                                                x.id
                                                            ).then((x) => {
                                                                Swal.fire({
                                                                    title: "Success",
                                                                    text: "A deleted card be restored later.",
                                                                    icon: "warning",
                                                                    showCancelButton: true,
                                                                    showConfirmButton: false,
                                                                    cancelButtonText:
                                                                        "Close",
                                                                    customClass:
                                                                        {
                                                                            cancelButton:
                                                                                "order-1 right-gap",
                                                                            confirmButton:
                                                                                "order-2",
                                                                            denyButton:
                                                                                "order-3",
                                                                        },
                                                                }).then((x) => {
                                                                    if (
                                                                        x.isDismissed
                                                                    ) {
                                                                        dispatch(
                                                                            fetchPaymentConfigRequest()
                                                                        );
                                                                    }
                                                                });
                                                            });
                                                        }
                                                    });
                                                }}
                                                className={`py-[7px] w-full px-5 bg-red-500 rounded-lg text-sm border border-orange-color font-bold text-white flex items-center justify-center capitalize ml-2 ${
                                                    x.id.indexOf("pm_") > -1
                                                        ? "opacity-50"
                                                        : ""
                                                }`}
                                            >
                                                <span className="mr-2.5">
                                                    <svg
                                                        width="18"
                                                        height="20"
                                                        viewBox="0 0 18 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M16 5L15.1327 17.1425C15.0579 18.1891 14.187 19 13.1378 19H4.86224C3.81296 19 2.94208 18.1891 2.86732 17.1425L2 5M7 9V15M11 9V15M12 5V2C12 1.44772 11.5523 1 11 1H7C6.44772 1 6 1.44772 6 2V5M1 5H17"
                                                            stroke="white"
                                                            stroke-width="1.5"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        />
                                                    </svg>
                                                </span>
                                                <span>Delete</span>
                                            </button>
                                        </div>
                                    </Grid>
                                );
                            })}
                    </Grid>
                </div>
            </div>
            <Dialog
                maxWidth="md"
                fullWidth
                open={showCard}
                onClose={() => setShowCard(false)}
            >
                <DialogContent>
                    <ManageCard
                        mode={selected.id ? "edit" : "add"}
                        card={selected}
                        onClose={() => setShowCard(false)}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Payment;
